import { AxiosInstance } from 'axios';
import { PaymentDto, PaymentFilter, PaymentTable } from 'models/api/payment';
import ResTable from 'models/api/table';
import { DropDown } from '@finbeat/react-toolkit';

export const getPaymentsList = async (axios: AxiosInstance, params?: PaymentFilter) => {
    const response = await axios.get<ResTable<PaymentTable>>('/payments', {
        params: { ...params },
    });
    return response.data;
};

export const getPaymentsExcel = async (axios: AxiosInstance, params?: PaymentFilter) => {
    const { data } = await axios.get<Blob>('/payments/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const deletePayment = async (axios: AxiosInstance, id: number | string) => {
    return await axios.delete(`/payments/${id}`);
};

export const getPaymentSourcesList = async (axios: AxiosInstance) => {
    const response = await axios.get<DropDown[]>('payments/sources');
    return response.data;
};

export const getPayment = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<PaymentDto>(`/payments/${id}`);
    return response.data;
};
